import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Home, Package, ArrowLeftRight, FileSpreadsheet, Settings, LogOut,
  ScrollText, ChevronDown, LayoutDashboard, Users, Trash2, MapPin,
  UserRound, Wrench, Factory, ShieldCheck, Calculator
} from 'lucide-react';
import { useLogowanie } from '../context/KontekstLogowania';
import { apiFetch } from '../services/api';

const Pasek = styled.aside`
  width: 238px;
  height: 100vh;
  position: fixed;
  inset: 0 auto 0 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(180deg,#0f2f59 0%,#102847 100%);
  color: #fff;
  box-shadow: 4px 0 24px rgba(15,47,89,.12);
  overflow-y: auto;
  z-index: 1200;
`;

const Brand = styled.div`
  padding: 24px 20px 18px;
  font-weight: 800;
  font-size: 16px;
  letter-spacing: .2px;
  border-bottom: 1px solid rgba(255,255,255,.1);
`;

const Gora = styled.div``;
const Menu = styled.div`padding: 14px 12px;`;

const LinkMenu = styled(NavLink)`
  color: rgba(255,255,255,.9);
  text-decoration: none;
  display:flex;
  align-items:center;
  gap:11px;
  padding:11px 12px;
  margin-bottom:5px;
  border-radius:9px;
  font-size:14px;
  transition:.18s ease;

  &:hover { background:rgba(255,255,255,.09); color:#fff; }
  &.active { background:#1f5fbf; color:#fff; box-shadow:0 8px 18px rgba(0,0,0,.14); }
`;

const AdminButton = styled.button`
  width:100%;
  color:rgba(255,255,255,.94);
  background:${({$active})=>$active ? 'rgba(31,95,191,.75)' : 'transparent'};
  border:0;
  cursor:pointer;
  display:flex;
  align-items:center;
  gap:11px;
  padding:11px 12px;
  margin-bottom:5px;
  border-radius:9px;
  font-size:14px;
  text-align:left;
  transition:.18s ease;

  &:hover { background:rgba(255,255,255,.09); color:#fff; }
`;

const AdminSubmenu = styled.div`
  margin:-1px 0 8px 18px;
  padding-left:10px;
  border-left:1px solid rgba(255,255,255,.15);
`;

const AdminSubLink = styled(NavLink)`
  color:rgba(255,255,255,.76);
  text-decoration:none;
  display:flex;
  align-items:center;
  gap:9px;
  min-height:34px;
  padding:7px 9px;
  margin:2px 0;
  border-radius:7px;
  font-size:12.5px;
  transition:.16s ease;

  &:hover { color:#fff; background:rgba(255,255,255,.07); }
  &.active { color:#fff; background:rgba(255,255,255,.11); font-weight:800; }
`;

const Badge = styled.span`
  margin-left:auto;
  min-width:20px;
  height:20px;
  padding:0 6px;
  border-radius:999px;
  display:inline-grid;
  place-items:center;
  background:#e5484d;
  color:#fff;
  font-size:10px;
  font-weight:900;
`;

const Dol = styled.div`
  padding:14px 12px 18px;
  border-top:1px solid rgba(255,255,255,.12);
`;

const User = styled.div`
  padding:10px 12px 12px;
  margin-bottom:8px;
`;

const RoleBadge = styled.div`
  display:inline-flex;
  align-items:center;
  gap:6px;
  margin-top:7px;
  padding:5px 8px;
  border-radius:999px;
  font-size:11px;
  font-weight:800;
  letter-spacing:.15px;
  background:rgba(255,255,255,.12);
  color:#fff;
  border:1px solid rgba(255,255,255,.16);
`;

const RoleDot = styled.span`
  width:7px;
  height:7px;
  border-radius:50%;
  background:${({$dot})=>$dot || '#fff'};
`;

const Wyloguj = styled.button`
  width:100%;
  color:white;
  background:transparent;
  border:0;
  cursor:pointer;
  display:flex;
  gap:9px;
  align-items:center;
  padding:10px 12px;
  border-radius:8px;
  &:hover { background:rgba(255,255,255,.09); }
`;

const adminItems = [
  ['dashboard','Dashboard',LayoutDashboard],
  ['uzytkownicy','Użytkownicy i konta',Users],
  ['wnioski','Wnioski o usunięcie',Trash2],
  ['lokalizacje','Lokalizacje',MapPin],
  ['pracownicy','Pracownicy',UserRound],
  ['firmy-serwisowe','Firmy serwisowe',Wrench],
  ['producenci','Producenci',Factory],
  ['role','Role i uprawnienia',ShieldCheck],
  ['logi','Logi',ScrollText],
];

export default function PasekBoczny() {
  const { uzytkownik, wyloguj, maUprawnienie } = useLogowanie();
  const location = useLocation();
  const navigate = useNavigate();
  const [adminOpen,setAdminOpen] = useState(location.pathname==='/administracja');
  const [oczekujace,setOczekujace] = useState(0);

  const roleConfig = {
    USER:{label:'Użytkownik',dot:'#cbd5e1'},
    OPERATOR:{label:'Operator ewidencji',dot:'#7dd3fc'},
    KSIEGOWY:{label:'Księgowy',dot:'#c4b5fd'},
    ADMIN:{label:'Administrator',dot:'#60a5fa'}
  };

  useEffect(()=>{
    if(location.pathname==='/administracja') setAdminOpen(true);
  },[location.pathname]);

  useEffect(()=>{
    if(!maUprawnienie('ASSET_DELETE_APPROVE')) return;

    let aktywny=true;
    const odswiezWnioski=()=>{
      apiFetch('/admin/wnioski-usuniecia?status=OCZEKUJE')
        .then(r=>{if(aktywny)setOczekujace(Array.isArray(r)?r.length:0);})
        .catch(()=>{if(aktywny)setOczekujace(0);});
    };

    odswiezWnioski();
    const timer=setInterval(odswiezWnioski,10000);
    window.addEventListener('focus',odswiezWnioski);

    return ()=>{
      aktywny=false;
      clearInterval(timer);
      window.removeEventListener('focus',odswiezWnioski);
    };
  },[maUprawnienie,location.pathname,location.search]);

  if (!uzytkownik) return null;
  const role = roleConfig[uzytkownik.rola] || roleConfig.USER;

  const otworzPanel = () => {
    setAdminOpen(v=>!v);
    if(location.pathname!=='/administracja') navigate('/administracja?sekcja=dashboard');
  };

  return (
    <Pasek>
      <Gora>
        <Brand>Ewidencja<br/>Środków Trwałych</Brand>
        <Menu>
          <LinkMenu to="/panel-glowny"><Home size={18}/>Panel główny</LinkMenu>
          <LinkMenu to="/srodki-trwale"><Package size={18}/>Środki trwałe</LinkMenu>
          <LinkMenu to="/przesuniecia"><ArrowLeftRight size={18}/>Przesunięcia</LinkMenu>
          <LinkMenu to="/raporty"><FileSpreadsheet size={18}/>Raporty</LinkMenu>
          {maUprawnienie('DEPRECIATION_VIEW') && <LinkMenu to="/amortyzacja"><Calculator size={18}/>Amortyzacja</LinkMenu>}

          {maUprawnienie('AUDIT_VIEW') && !maUprawnienie('ADMIN_PANEL') &&
            <LinkMenu to="/logi"><ScrollText size={18}/>Logi</LinkMenu>}

          {maUprawnienie('ADMIN_PANEL') && <>
            <AdminButton $active={location.pathname==='/administracja'} onClick={otworzPanel}>
              <Settings size={18}/>
              <span>Panel administratora</span>
              {oczekujace>0 && !adminOpen && <Badge>{oczekujace}</Badge>}
              <ChevronDown size={16} style={{
                marginLeft:oczekujace>0 && !adminOpen ? 0 : 'auto',
                transform:adminOpen?'rotate(180deg)':'rotate(0deg)',
                transition:'transform .18s ease'
              }}/>
            </AdminButton>

            {adminOpen && <AdminSubmenu>
              {adminItems.map(([key,label,Icon])=>
                <AdminSubLink
                  key={key}
                  to={`/administracja?sekcja=${key}`}
                  className={()=>{
                    const params=new URLSearchParams(location.search);
                    const current=params.get('sekcja')||'dashboard';
                    return location.pathname==='/administracja' && current===key ? 'active' : '';
                  }}
                >
                  <Icon size={15}/>
                  <span>{label}</span>
                  {key==='wnioski' && oczekujace>0 && <Badge>{oczekujace}</Badge>}
                </AdminSubLink>
              )}
            </AdminSubmenu>}
          </>}
        </Menu>
      </Gora>

      <Dol>
        <User>
          <div style={{fontWeight:750,fontSize:14}}>{uzytkownik.imie} {uzytkownik.nazwisko}</div>
          <RoleBadge>
            <RoleDot $dot={role.dot}/>
            {role.label}
          </RoleBadge>
        </User>
        <Wyloguj onClick={wyloguj}><LogOut size={18}/>Wyloguj</Wyloguj>
      </Dol>
    </Pasek>
  );
}
